
import { Component, Prop, Emit, Vue } from 'vue-property-decorator';
import store from '@/store';
import { isVisibleLineBanner } from '@/lib/functions';

@Component
export default class BoxEntriesHeaderTitle extends Vue {
  private name = 'BoxEntriesHeaderTitle';
  @Prop()
  private title!: string;
  get lang(): string {
    return store.getters['auth/lang'];
  }
  get isGroup(): boolean {
    return this.$store.getters['auth/group'];
  }
  get visibleLineBanner(): boolean {
    return isVisibleLineBanner({
      lang: store.getters['auth/lang'],
      group: store.getters['auth/group'],
      isLineLogin: store.getters['auth/line'],
    });
  }
}
